<template>
  <div class="blueBg">
    <POS></POS>
    <!-- <POSV2></POSV2> -->
    <!-- <POSV3></POSV3> -->
  </div>
</template>

<script>
import POS from '@/components/POS.vue';
// import POSV2 from '@/components/POSV2.vue'
// import POSV3 from '@/components/POSV3.vue'

export default {
  name: "PosView",
  components: {
    POS,
    // POSV2,
    // POSV3,
  }

};
</script>

<style scoped>
.blueBg {
  background-color: lavender;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100dvh;
}

@media (max-width: 440px) {
  .blueBg {
    padding: 0;
    background-color: white;
  }
}
</style>
